//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import * as React from "react";
import { RedocStandalone } from "redoc";
import { REDOC_THEME } from "src/common/constant";

export interface IDestinationComponentProps {
    yamlFile: any;
}

export class DestinationComponent extends React.Component<IDestinationComponentProps, any> {
    render() {
        return (
            <div>
                <RedocStandalone specUrl={this.props.yamlFile}
                    options={{
                        nativeScrollbars: true,
                        theme: REDOC_THEME,
                    }}
                />
            </div>
        )
    }
}

export default DestinationComponent;
